import { apiGet, apiPost } from '@/utils/httpClient'
import { TranslationSegment } from '@/models/TranslationSegment';

export const segmentsApi = {
    updateTranslationState(translation: TranslationSegment) {
        return apiPost('segments/update', translation);
    },

    getDocumentSegments(settings: any) {
        return apiPost('segments/load', settings);
    },

    findNextWorkSegment(documentId: number, pageSize: number, segmentId: number) {
        return apiPost(`segments/nextWorkSegment?documentId=${documentId}&pageSize=${pageSize}&segmentId=${segmentId}`);
    },

    searchSegments(request: any) {
        return apiPost('segments/search', request);
    },

    clearFileTranslations(documentId: number, pageSize: number) {
        return apiPost(`segments/clearTranslations?documentId=${documentId}&pageSize=${pageSize}`);
    },

    mergeSegments(mergeRequest: any) {
        return apiPost(`segments/mergeSegments`, mergeRequest);
    },

    getParagraphContinuation(afterSegmentId: number, limit: number, paragraphId?: string) {
        let url = `segments/paragraphContinuation?afterSegmentId=${afterSegmentId}&limit=${limit}`;
        if (paragraphId) {
            url += `&paragraphId=${paragraphId}`;
        }
        return apiGet(url);
    },

    getMergedSegments(segmentToSplitId: number) {
       return apiGet(`segments/mergedSegments?segmentId=${segmentToSplitId}`);

    },

    splitMergedSegments(splitRequest: any) {
        return apiPost(`segments/splitMergedSegments`, splitRequest);

    }
}
